import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {RequestService} from "../../../../core/services/request/request.service";
import {CatalogDataModel} from "../../../../core/services/catalog-data/catalog-data.model";
import {ActionQuestionOverlayService} from "../../services/action-question-overlay/action-question-overlay.service";
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {UtilService} from "../../../../core/services/util/util.service";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {$translate} from "../../../../core/services/internationalization/localize.service";
import {CatalogRequestCreatedEvent} from "../catalog-form/catalog-request-created-event.model";

@Component({
  selector: 'sb-action-question-overlay',
  templateUrl: './action-question-overlay.component.html',
  styleUrls: ['./action-question-overlay.component.scss']
})
export class ActionQuestionOverlayComponent implements OnInit, OnDestroy {

  @ViewChild('cronExpressionDialog', {static: false}) ejDialog: DialogComponent;

  @Input()
  recordId: string;

  @Input()
  recordTable: string;

  @Input()
  nluModel: any = null;

  // An optional related Request ID. This would be set if a catalog item/questions were to be related to an existing record
  // I.e. instead of creating a new record. If this is null, a new record with a new ID will be created.
  @Input()
  requestID: any = null;

  @Input()
  sourceRec: any = null;

  @Input()
  sourceIsNewRecord: boolean = false;

  @Input()
  resolve: (val: any) => void;

  subscription: Subscription;

  item: CatalogDataModel = null;

  visible = false;

  buttons: ButtonPropsModel[] = [
    {
      'click': () => { this.ejDialog.hide() },
      buttonModel: {
        content: $translate("common.button.close")`Close`,
        isPrimary: true,
      }
    },
  ];

  constructor(private host: ElementRef,
              private utilService: UtilService,
              private actionQuestionOverlayService: ActionQuestionOverlayService,
              private router: Router,
              private requestService: RequestService) {
    this.host.nativeElement.show = this.showDialog.bind(this);
    this.host.nativeElement.hide = this.hideDialog.bind(this);
  }

  async getCatalogueItem () {

    const response: any = await this.requestService.createRequest()
      .controller("servicely.core.Portal")
      .method("getCatalogItemByID")
      .data({ id: this.recordId })
      .execute();

    if (response["data"] == null) {
      alert("Error: No data was not returned from the catalog item: " + this.recordId);
      this.removeElement();
    } else {
      this.item = JSON.parse(response.data);
    }
  }

  ngOnInit() {
    this.subscription = this.router.events.subscribe((e) => {
      this.removeElement();
    });

    this.getCatalogueItem();
  }

  ngOnDestroy(): void {
      this.subscription && this.subscription.unsubscribe();
      this.actionQuestionOverlayService.deregisterModal(this.recordId, this.recordTable);
  }

  showDialog() {
    this.visible = true;
    // Give the dialog a chance to build (as there is an ngIf around it)
    this.utilService.tickThen(() => {
      this.ejDialog.show();
    });
  }

  hideDialog() {
    this.visible = false;
    this.doResolve(null);
    this.removeElement();
  }

  onRequestCreated (event: CatalogRequestCreatedEvent) {
    this.doResolve(event.requestId);
    this.removeElement();
  }

  onClose($event: any) {
    if ($event.closedBy == "close icon" || $event.closedBy == "escape") {
      this.doResolve(null);
    }
    this.removeElement();
  }

  removeElement() {
    this.host.nativeElement.remove();
  }

  doResolve(val) {
    this.resolve && this.resolve(val);
  }
}
